"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dialog = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var components_1 = require("../Modal/components");
var __1 = require("../");
var Dialog = function (_a) {
    var _b = _a.open, open = _b === void 0 ? false : _b, children = _a.children, className = _a.className, onClose = _a.onClose, title = _a.title, actionsLayout = _a.actionsLayout, negative = _a.negative, onPrimaryActionClick = _a.onPrimaryActionClick, onSecondaryActionClick = _a.onSecondaryActionClick, primaryActionName = _a.primaryActionName, secondaryActionName = _a.secondaryActionName, focusScopeOptions = _a.focusScopeOptions, rest = __rest(_a, ["open", "children", "className", "onClose", "title", "actionsLayout", "negative", "onPrimaryActionClick", "onSecondaryActionClick", "primaryActionName", "secondaryActionName", "focusScopeOptions"]);
    react_1.default.useEffect(function () {
        if (rest.closable) {
            console.warn('@servicetitan/design-system: The `closable` prop of the Dialog component will be removed in a future release. It also never worked. Please remove.');
        }
    });
    var DialogClasses = classnames_1.default('Dialog', className);
    return (open && (react_1.default.createElement(components_1.ModalWindow, __assign({ className: DialogClasses, onClose: onClose, size: components_1.ModalSizes.XS, focusScopeOptions: focusScopeOptions }, rest),
        react_1.default.createElement(components_1.ModalHeader, { onClose: onClose, title: title, className: "Dialog__header" }),
        react_1.default.createElement(components_1.ModalContent, { className: "Dialog__content" }, children),
        react_1.default.createElement(components_1.ModalFooter, { className: "Dialog__footer" },
            react_1.default.createElement(DialogActions, { actionsLayout: actionsLayout, negative: negative, onPrimaryActionClick: onPrimaryActionClick, onSecondaryActionClick: onSecondaryActionClick, primaryActionName: primaryActionName, secondaryActionName: secondaryActionName })))));
};
exports.Dialog = Dialog;
var DialogActions = function (props) {
    var _a = props.actionsLayout, actionsLayout = _a === void 0 ? 'row' : _a, negative = props.negative, onPrimaryActionClick = props.onPrimaryActionClick, onSecondaryActionClick = props.onSecondaryActionClick, primaryActionName = props.primaryActionName, secondaryActionName = props.secondaryActionName;
    var hasPrimaryAction = !!(primaryActionName && onPrimaryActionClick);
    var hasSecondaryAction = !!(secondaryActionName && onSecondaryActionClick);
    var _b = useClientRect(), primaryRect = _b[0], primaryRef = _b[1];
    var _c = useClientRect(), secondaryRect = _c[0], secondaryRef = _c[1];
    var checkActionsWrapped = actionsLayout.includes('row') &&
        primaryRect !== null &&
        secondaryRect !== null &&
        Math.round(primaryRect.top - secondaryRect.top) !== 0; // Check whether action buttons placed on different lines
    var columnedButtons = checkActionsWrapped || actionsLayout.includes('column');
    return hasSecondaryAction && hasPrimaryAction ? (react_1.default.createElement(__1.Stack, { alignItems: columnedButtons ? 'stretch' : null, className: columnedButtons ? 'w-100' : null, direction: checkActionsWrapped ? 'column-reverse' : actionsLayout, spacing: columnedButtons ? 1 : 2, wrap: "wrap" },
        react_1.default.createElement("span", { ref: secondaryRef },
            react_1.default.createElement(__1.Button, { full: true, small: true, onClick: onSecondaryActionClick }, secondaryActionName)),
        react_1.default.createElement("span", { ref: primaryRef },
            react_1.default.createElement(__1.Button, { full: true, primary: true, small: true, negative: negative, onClick: onPrimaryActionClick }, primaryActionName)))) : (react_1.default.createElement(__1.Button, { primary: true, small: true, onClick: onPrimaryActionClick }, primaryActionName));
};
exports.Dialog.Window = components_1.ModalWindow;
exports.Dialog.Header = components_1.ModalHeader;
exports.Dialog.Content = components_1.ModalContent;
exports.Dialog.Footer = components_1.ModalFooter;
/** https://reactjs.org/docs/hooks-faq.html#how-can-i-measure-a-dom-node */
var useClientRect = function () {
    var _a = react_1.default.useState(null), rect = _a[0], setRect = _a[1];
    var ref = react_1.default.useCallback(function (node) {
        if (node !== null) {
            setRect(node.getBoundingClientRect());
        }
    }, []);
    return [rect, ref];
};
//# sourceMappingURL=Dialog.js.map